import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurveLineSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 241 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 58L49.8424 54.1726C51.2766 54.0579 52.6943 53.7887 54.0707 53.3698L93.1874 41.4647C96.3466 40.5032 99.6947 40.3389 102.933 40.9866L134.532 47.3064C136.826 47.7652 139.183 47.818 141.496 47.4622L178.873 41.7119C181.916 41.2436 184.811 40.0788 187.331 38.3083L239 2",
		stroke: "#E7E5E4",
		strokeWidth: 3,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgCurveLineSmall);
export { ForwardRef as ReactComponent };
